exports.L = {
  bit: 1
};
exports.M = {
  bit: 0
};
exports.Q = {
  bit: 3
};
exports.H = {
  bit: 2
};
function f1556(p12439) {
  if (typeof p12439 != "string") {
    throw new Error("Param is not a string");
  }
  const v9890 = p12439.toLowerCase();
  switch (v9890) {
    case "l":
    case "low":
      return exports.L;
    case "m":
    case "medium":
      return exports.M;
    case "q":
    case "quartile":
      return exports.Q;
    case "h":
    case "high":
      return exports.H;
    default:
      throw new Error("Unknown EC Level: " + p12439);
  }
}
exports.isValid = function (p12440) {
  return p12440 && typeof p12440.bit != "undefined" && p12440.bit >= 0 && p12440.bit < 4;
};
exports.from = function (p12441, p12442) {
  if (exports.isValid(p12441)) {
    return p12441;
  }
  try {
    return f1556(p12441);
  } catch (e89) {
    return p12442;
  }
};